class MeevyaCartScroll extends HTMLElement {
  connectedCallback() {
    this.frame = requestAnimationFrame(() => { if (this.isConnected) this.initialize(); });
  }
  initialize() {
    this.hidden = true;
    this.root = this.parentElement?.querySelector('.cart-drawer__content');
    this.button = this.querySelector('button');
    this.price = this.querySelector('.meevya-cart-scroll__price');
    if (!this.root || !this.button || !this.price) return;
    this.sync = () => {
      const checkout = this.root.querySelector('.cart__checkout-button');
      if (checkout !== this.checkout) {
        this.observer?.disconnect();
        this.checkout = checkout;
        if (checkout) this.observer.observe(checkout);
      }
      const price = this.root.querySelector('.meevya-cart-checkout-price, [data-cart-subtotal]');
      this.price.textContent = price?.textContent?.trim() || '';
      this.button.disabled = !checkout || checkout.disabled;
      if (!checkout) this.hidden = true;
    };
    this.observer = new IntersectionObserver(([entry]) => {
      const visible = entry.isIntersecting && entry.intersectionRatio >= 0.99;
      if (visible && this.contains(document.activeElement)) this.checkout?.focus({ preventScroll: true });
      this.hidden = visible || !this.checkout;
    }, { root: this.root, rootMargin: '0px 0px -80px 0px', threshold: [0, 0.99, 1] });
    this.click = () => {
      if (document.documentElement.hasAttribute('data-meevya-cart-pending')) return;
      this.sync();
      if (!this.button.disabled) this.checkout?.click();
    };
    this.button.addEventListener('click', this.click);
    this.mutations = new MutationObserver(this.sync);
    this.mutations.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    this.sync();
  }
  disconnectedCallback() {
    cancelAnimationFrame(this.frame);
    this.observer?.disconnect();
    this.mutations?.disconnect();
    this.button?.removeEventListener('click', this.click);
  }
}
if (!customElements.get('meevya-cart-scroll')) customElements.define('meevya-cart-scroll', MeevyaCartScroll);
